<div class="available-products-info"
  [innerHtml]="'<span class=\'available-products\'>'+numberOfAvailableProducts+'</span> '+(referenceDataLabels.ProductPickerShowing|localizeLabel)|formatString:[products.length]">
</div>

<div class="product-picker-sort-wrapper">
  <span class="bo-label-text" [innerHtml]="(isCriteriaSearch?referenceDataLabels.ProductPickerAvailableProducts:referenceDataLabels.ProductPickerMortgageProducts)|localizeLabel"></span>
  <div class="product-picker-sort" *ngIf="isCriteriaSearch">
    <span class="sort-by-label" [innerHtml]="referenceDataLabels.ProductPickerSortBy|localizeLabel"></span>
    <kendo-dropdownlist [data]="sortOptions" textField="Value" [(ngModel)]="selectedSortOption"
      (ngModelChange)="updateSelectedSortOption()">
    </kendo-dropdownlist>
  </div>
</div>


<ng-template #notSpecificSearch>
  <span [innerHtml]="referenceDataLabels.ProductPickerEnterCriteria|localizeLabel"></span>
</ng-template>

<table class="products-table" *ngIf="products.length > 0">
  <tr>
    <th>
      <label [innerHtml]="referenceDataLabels.ProductPickerMortgageProductName|localizeLabel"></label>
      <boi-tooltip [tooltipName]="referenceDataLabels.ProductPickerMortgageProductName"></boi-tooltip>
    </th>
    <th class="col-width-180">
      <label [innerHtml]="referenceDataLabels.ProductPickerGridStandardRate|localizeLabel"></label>
      <boi-tooltip [tooltipName]="referenceDataLabels.ProductPickerGridStandardRate"></boi-tooltip>
    </th>
    <th class="col-width-90">
      <label [innerHtml]="referenceDataLabels.ProductPickerGridOverallCost|localizeLabel"></label>
      <boi-tooltip [tooltipName]="referenceDataLabels.ProductPickerGridOverallCost"></boi-tooltip>
    </th>
    <th class="col-width-90">
      <label [innerHtml]="referenceDataLabels.ProductPickerGridMaximumLTV|localizeLabel"></label>
      <boi-tooltip [tooltipName]="referenceDataLabels.ProductPickerGridMaximumLTV"></boi-tooltip>
    </th>
    <th class="col-width-90">
      <label [innerHtml]="referenceDataLabels.ProductPickerGridFees|localizeLabel"></label>
      <boi-tooltip [tooltipName]="referenceDataLabels.ProductPickerGridFees"></boi-tooltip>
    </th>
    <th>
      <label [innerHtml]="referenceDataLabels.ProductPickerGridPromotionalRatePeriodCost|localizeLabel"></label>
      <boi-tooltip [tooltipName]="referenceDataLabels.ProductPickerGridPromotionalRatePeriodCost"></boi-tooltip>
    </th>
    <th>
      <label [innerHtml]="referenceDataLabels.ProductPickerGridBalanceRemaining|localizeLabel"></label>
      <boi-tooltip [tooltipName]="referenceDataLabels.ProductPickerGridBalanceRemaining"></boi-tooltip>
    </th>
    <th>
      <label [innerHtml]="referenceDataLabels.ProductPickerGridComparativeTotal|localizeLabel"></label>
      <boi-tooltip [tooltipName]="referenceDataLabels.ProductPickerGridComparativeTotal"></boi-tooltip>
    </th>
    <th>
      <label [innerHtml]="referenceDataLabels.ProductPickerGridMonthlyRepayments|localizeLabel"></label>
      <boi-tooltip [tooltipName]="referenceDataLabels.ProductPickerGridMonthlyRepayments"></boi-tooltip>
    </th>
  </tr>
  <ng-container *ngFor="let product of products; trackBy: trackByProductId">
    <tr [ngClass]="{'error-product': product.ValidationErrors?.FullValidationErrors?.length > 1}" class="main-data-row">

      <td>
        <span [innerHtml]="product.Entity.ProductName"></span>
      </td>

      <td>
        <strong [innerHtml]="product.Entity.Rate + ' % '"></strong>
        <span>{{product.Entity.TermOther}}</span>       
      </td>

      <td [ngClass]="{'highlighted-cell': selectedSortOption.Code === 'OverallCost'}">
        <span [innerHtml]="product.Entity.TypApr + ' %'"></span>
      </td>

      <td [ngClass]="{'highlighted-cell': selectedSortOption.Code === 'MaxLtv'}">
        <span [innerHtml]="product.Entity.MaxLtv + ' %'"></span>
      </td>

      <td [ngClass]="{'highlighted-cell': selectedSortOption.Code === 'ArrangementFee'}">
        <span
          [innerHtml]="product.Entity.ArrangementFee | currency : (referenceDataLabels.Currency | localizeLabel) + '&nbsp;'"></span>
      </td>

      <td
        [ngClass]="{'disabled-text': !isCriteriaSearch, 'highlighted-cell': selectedSortOption.Code === 'PromotionalRatePeriodCost'}">
        <ng-container *ngIf="!(product.ValidationErrors?.FullValidationErrors?.length > 1)">
          <ng-container *ngIf="product.Entity.IsAvailable; else notSpecificSearch">
            <strong
              [innerHtml]="product.Entity.PromotionalRatePeriodCost | currency : (referenceDataLabels.Currency | localizeLabel) + '&nbsp;'"></strong>
          </ng-container>
        </ng-container>
      </td>

      <td
        [ngClass]="{'disabled-text': !isCriteriaSearch, 'highlighted-cell': selectedSortOption.Code === 'BalanceRemaining'}">
        <ng-container *ngIf="!(product.ValidationErrors?.FullValidationErrors?.length > 1)">
          <ng-container *ngIf="product.Entity.IsAvailable; else notSpecificSearch">
            <strong
              [innerHtml]="product.Entity.BalanceRemaining | currency : (referenceDataLabels.Currency | localizeLabel) + '&nbsp;'"></strong>
          </ng-container>
        </ng-container>
      </td>

      <td [ngClass]="{'disabled-text': !isCriteriaSearch}">
        <ng-container *ngIf="!(product.ValidationErrors?.FullValidationErrors?.length > 1)">
          <ng-container *ngIf="product.Entity.IsAvailable; else notSpecificSearch">
            <strong
              [innerHtml]="product.Entity.ComparativeTotal | currency : (referenceDataLabels.Currency | localizeLabel) + '&nbsp;'"></strong>
          </ng-container>
        </ng-container>
      </td>

      <td [ngClass]="{'disabled-text': !isCriteriaSearch}" class="highlighted-cell">

        <ng-container *ngIf="product.ValidationErrors?.FullValidationErrors?.length > 1; else monthlyRepayments">
          <span [innerHtml]="referenceDataLabels.ProductPickerErrorMessage|localizeLabel"></span>
          <span class="error-msg"
            *ngFor="let validationError of product.ValidationErrors?.FullValidationErrors | slice:1"
            [innerHtml]="validationError.name|localizeErrorMessage:validationError.code:validationError.args:validationError.key">
          </span>
        </ng-container>

        <ng-template #monthlyRepayments>
          <ng-container *ngIf="product.Entity.IsAvailable; else notSpecificSearch">
            <strong
              [innerHtml]="product.Entity.MonthlyRepayments | currency : (referenceDataLabels.Currency | localizeLabel) + '&nbsp;'"></strong>
          </ng-container>
        </ng-template>

      </td>
    </tr>

    <tr [ngClass]="{'error-product': product.ValidationErrors?.FullValidationErrors?.length > 1}">
      <td colspan="9">
        <div class="action-row">
          <div>
            <div class="bo-label-text" [innerHtml]="referenceDataLabels.ProductDetailsHeader|localizeLabel"></div>
            <div *ngIf="product.Entity.EarlyRedemptionCharge" [innerHtml]="product.Entity.EarlyRedemptionCharge"></div>
            <div *ngIf="product.Entity.Description" [innerHtml]="product.Entity.Description"></div>
          </div>
          <button class="secondary-button continue" [disabled]="!product.Entity.IsAvailable || isSelectionDisabled"
            [innerHtml]="referenceDataLabels.ProductPickerNextButton|localizeLabel"
            (click)="chooseProduct(product.Entity)"></button>
        </div>

      </td>
    </tr>
    <tr class="product-bottom-delimiter"></tr>
  </ng-container>
</table>

<boi-product-special-features-dialog class="vo-modal vo-modal--standard" [(opened)]="isProductSpecialFeatureDialogOpen"
  [titleLabel]="referenceDataLabels.ProductPickerSpecialFeatureTitle"
  [confirmationLabel]="referenceDataLabels.ProductPickerSpecialFeatureContent"
  [confirmationButtonLabel]="referenceDataLabels.ConfirmProductWithSpecialFeature"
  [data]="selectedProduct?.ProductSpecialFeatures" (confirmAction)="confirmProduct()"
  (cancelAction)="cancelProductSpecialFeatures()">
</boi-product-special-features-dialog>